// Dumb card — no store, no SQL. A label, an animated number and an optional info tooltip.
//
// Four OPT-IN props (AM_ABSORPTION_PLAN step C1 — standalone asset-management's KpiCard, folded in
// here instead of a second card). All default off, and off they change nothing: the element tree,
// its props and its text are the ones this card rendered before them (project-overview's
// Controllers cards and TotalAndAssignedCards' sub-items card pass none).
//   formatValue  (Function|null) the DISPLAYED (animated) number → its text, e.g. a percentage;
//                null → the number as is
//   valueColor   (String) a CSS colour for the number (the caller takes it from @rdrive/theme,
//                e.g. `chartTheme(mode).semantic.serious`); '' → no style attribute
//   selectable   (Boolean) the card is a toggle: a click (or Enter/Space) emits `select`, the card
//                is a focusable role="button" with aria-pressed, a pointer cursor and Vuetify's
//                clickable-card states; its title gains a right-aligned filter icon while `active`.
//                false → no listener, no class, no attribute
//   active       (Boolean) read only while `selectable`: the outline + filter icon
//   emits:  select  ()  only while `selectable` — the parent owns the selection and flips `active`
import setup from './setup.js';

export default {
  name: 'total-card',
  props: {
    label: {
      type: String,
      required: true
    },
    count: {
      type: Number,
      required: true
    },
    tooltip: {
      type: String,
      required: false
    },
    formatValue: {
      type: Function,
      default: null
    },
    valueColor: {
      type: String,
      default: ''
    },
    selectable: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    // Opt-in compact look (AM_ABSORPTION_PLAN C1, Daniel 2026-10-16): small wrapping label,
    // smaller number, rounded corners — standalone asset-management's KpiCard
    dense: {
      type: Boolean,
      default: false
    }
  },
  emits: ['select'],
  setup,
};
